module.exports = "<div class=\"add-player-to-group-modal\">\r\n\r\n\t<div class=\"players-list\">\r\n\r\n\t</div>\r\n\r\n\t<button class=\"btn btn-primary btn-close\">\r\n\t\tClose\r\n\t</button>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/admin-section/groups/group/_modals/add-player-to-group-modal/add-player-to-group.tpl.html
// module id = 87
// module chunks = 0